import {
  requiredString,
  requiredPositiveInteger,
  createResourceSchema
} from './common'

export const courseSchema = createResourceSchema({
  name: requiredString('Name'),
  hole_count: requiredPositiveInteger('Number of holes')
})
